var map = {
	"./cognos.jpg": 4484,
	"./edteam.png": 3600,
	"./iti.png": 9160,
	"./mintic.png": 1060,
	"./platzi.png": 5854,
	"./sena.png": 3430,
	"./udec.png": 6513,
	"./udemy.png": 4748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8093;